var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{style:({ height: _vm.viewportHeight }),attrs:{"src":_vm.url,"id":"iframe"}})
}
var staticRenderFns = []

export { render, staticRenderFns }